export function isArrayEqual<T>(
	arr1: T[],
	arr2: T[],
	compareFn?: (a: T, b: T) => number
): boolean {
	if (arr1.length !== arr2.length) return false;
	const sortedArr1 = [...arr1].sort(compareFn);
	const sortedArr2 = [...arr2].sort(compareFn);
	for (let i = 0; i < sortedArr1.length; i++) {
		if (
			compareFn
				? compareFn(sortedArr1[i], sortedArr2[i]) !== 0
				: sortedArr1[i] !== sortedArr2[i]
		) {
			return false;
		}
	}
	return true;
}
